import React, { useEffect, useState } from "react";
import ContentPageTitle from "../../../common/ContentPageTitle";
import { useManagementOrdersUser } from "../../../hooks/useManagementOrdersUser";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, Link } from "react-router-dom";
import { getRestaurantsList } from "../../../features/reducers/restaurants";
import OrderSettingsUser from "./OrderSettingsUser";
import axiosWithAuth from "../../../utils/axiosWithAuth";
import { Tabs, Spin } from "antd";

export default function ManageOrdersUser(props) {
  const { user } = props;

  const [ordersList, setOrdersList] = useState({
    readyOrders: [],
    shippedOrders: [],
    pendingPaymentOrders: [],
    completedOrders: [],
    canceledOrders: [],
    processingOrders: [],
  });

  const [isLoading, setIsLoading] = useState({
    readyOrders: false,
    canceledOrders: false,
    pendingPaymentOrders: false,
    processingOrders: false,
    shippedOrders: false,
    completedOrders: false,
  });

  useEffect(() => {
    getAllOrders();
  }, [user.id]);

  const hookData = {
    creatorID: user.id,
    dispatchAction: getRestaurantsList(user.id),
    deleteItemAPI: "/api/products/delete",
    user: user,
    itemType: "products",
    type: "restaurant",
    modalData: {
      title: "Create New Menu Item",
      fieldLabel: "Menu Item Name",
    },
  };

  const getAllOrders = async () => {
    try {
      setIsLoading((prevState) => ({
        ...prevState,
        readyOrders: true,
        canceledOrders: true,
        pendingPaymentOrders: true,
        processingOrders: true,
        shippedOrders: true,
        completedOrders: true,
      }));

      const response = await axiosWithAuth().get(
        `/api/restaurant/order/allOrdersFromUser`,
      );

      setOrdersList(response.data?.data ?? {});
    } catch (error) {
      console.error("Error getting orders:", error);
    } finally {
      setIsLoading((prevState) => ({
        readyOrders: false,
        canceledOrders: false,
        pendingPaymentOrders: false,
        processingOrders: false,
        shippedOrders: false,
        completedOrders: false,
      }));
    }
  };

  const [/*modalComponent,*/ ListComponent] = useManagementOrdersUser(hookData);

  const renderTabContent = (ordersType, isLoading) => (
    <>
      {isLoading ? (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <Spin size="large" />
        </div>
      ) : (
        <ListComponent
          emptyMessage="No orders found."
          listItems={ordersList[ordersType]}
        />
      )}
    </>
  );

  return (
    <div id="orders-page">
      <div className="content-box">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Tabs defaultActiveKey="1" type="card" size="default">
                  <Tabs.TabPane tab="Processing Orders" key="1">
                    {renderTabContent(
                      "processingOrders",
                      isLoading.processingOrders,
                    )}
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Ready Orders" key="2">
                    {renderTabContent(
                      "readyOrders",
                      isLoading.readyOrders,
                    )}
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="On the way" key="3">
                    {renderTabContent("shippedOrders", isLoading.shippedOrders)}
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Completed Orders" key="4">
                    {renderTabContent(
                      "completedOrders",
                      isLoading.completedOrders,
                    )}
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Canceled Orders" key="5">
                    {renderTabContent(
                      "canceledOrders",
                      isLoading.canceledOrders,
                    )}
                  </Tabs.TabPane>
                </Tabs>
              </>
            }
            exact
          />

          <Route path="/:id" element={<OrderSettingsUser />} exact />
        </Routes>
      </div>

      {/* {modalComponent} */}
    </div>
  );
}
